import { Input } from '@/components/ui/input'
import type { InputProps } from '../input-props'

export function NumberInput({ value, onChange, onBlur, disabled, invalid }: InputProps) {
  return (
    <Input
      type="number"
      value={value === null || value === undefined ? '' : (value as string | number)}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      onBlur={onBlur}
      disabled={disabled}
      aria-invalid={invalid || undefined}
      dir="ltr"
    />
  )
}
